<template>
  <div class="welcome-two">
    <div class="flex-layout">
      <div class="flex-item" style="text-align: center;">
        <el-radio-group v-model="radio" class="left">
          <el-radio :label="1">
            <div class="radio-title">Single Network Profile</div>
            <div class="radio-content">
              There is a preconfigured VLAN: Default with VLAN ID 1
            </div>
          </el-radio>
          <el-radio :label="2">
            <div class="radio-title">Multiple Network Profile</div>
            <div class="radio-content">
              In cases of larger deployments, multiple networks are required and need multiple network profiles
            </div>
          </el-radio>
        </el-radio-group>
        <div class="welcome-toolbar right" id="welcome_next_button">
          <el-button type="primary" @click="nextHandler">Next</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const radio = ref(1)
const router = useRouter()

const nextHandler = () => {
  router.push({ path: '/configure/overview' })
}
</script>


<style scoped>
  .radio-title {
    font-size: 16px;
    font-weight: bold;
    color: #5a5a5a;
  }
  .radio-content{
    font-size: 14px;
    color: #7e7e7e;
    padding-top: 10px;
  }
  .welcome-toolbar {
    padding-right: 300px;
    padding-top: 50px;
  }
</style>
